<template>
  <div
    :class="b()"
  >
    <div
      :class="b('drag-bar', {active: hovering})"
      @mousedown="handleDown"
      @touchstart="handleDown"
    ></div>
    <!-- v-ripple -->
    <div
      v-if="isOverseasVersion"
      :class="b('oversea-button', {collapse: asideCollapse && transitionEndTime >= toggleTime, showDrawer})"
      :style="{
        marginTop: overseaButtonMarginTop + 'px'
      }"
      @click="toggleAside"
    >
      <em :class="['zkicon', asideCollapse ? 'iconicon_daohangzhankai' : 'iconicon_daohangshouqi']" />
    </div>
    <div
      v-else
      :class="b('button', {collapse: asideCollapse})"
      @click="toggleAside"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    >
      <em class="zkicon iconshouqi" />
    </div>
  </div>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
const DRAG_INSTANCE = 10;
export default {
  name: 'AsideToggle',
  bemNS: theme.bemNS,
  props:{
    collapse: {
      type: Boolean,
      default: false
    },
    isOverseasVersion: {
      type: Boolean,
      default: false
    },
    transitionEndTime: {
      type: Number,
      default: 0
    },
    showDrawer: {
      type: Boolean,
      default: false
    },
    asideTop: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      dragging: false,
      toggleTime: 0,
      asideCollapse: undefined,
      hovering: false
    };
  },
  computed: {
    overseaButtonMarginTop(){
      return this.asideCollapse && this.transitionEndTime >= this.toggleTime ? this.asideTop : 0;
    }
  },
  watch: {
    collapse: {
      handler(val) {
        if (this.asideCollapse === undefined) {
          this.asideCollapse = val;
        } else {
          setTimeout(()=>{
            this.asideCollapse = val;
          }, 280);
        }

      },
      immediate: true
    }
  },
  methods: {
    handleDown(event) {
      event.preventDefault();
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging);
      window.addEventListener('touchmove', this.onDragging);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('touchend', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    // 拖拽调整宽度
    onDragging(){

    },
    onDragEnd(event){
      if (this.dragging) {
        console.log(event.clientX, this.startX, 123456);
        if (event.clientX - this.startX > DRAG_INSTANCE && this.collapse) {
          this.toggleAside();
        } else if (this.startX - event.clientX > DRAG_INSTANCE && !this.collapse) {
          this.toggleAside();
        }
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('touchmove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
        this.dragging = false;
      }
    },
    onDragStart(event) {
      this.dragging = true;
      this.startX = event.clientX;
    },
    toggleAside(){
      this.toggleTime = +new Date();
      this.$emit('toggleAside');
    }
  }

};
</script>
<style lang="scss">
$barBg: rgba(127, 121, 235, 1);
$heapArea: 10px;
@include b(aside-toggle) {
  position: absolute;
  right: -4px;
  top: 0;
  bottom: 0;
  padding-left: $heapArea;
  // border-left: 4px solid transparent;
  // border-right: 4px solid transparent;
  z-index: 999;
  @include e(drag-bar){
    cursor: col-resize;
    height:100%;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    transition: all 0.5s;
    // border-right: 4px solid $barBg;
    &:hover{
      border-right-color: $barBg;
    }
    @include m(active){
      border-right-color: $barBg;
    }
  }
  @include e(button){
    z-index: 11;
    position: absolute;
    top: calc(50% - 25px);
    // right: -16px;
    left: calc(4px + $heapArea);
    cursor: pointer;
    width: 16px;
    height: 50px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #575872;
    display: flex;
    // pointer-events: none;
    // visibility: hidden;
    opacity: 0;
    align-items: center;
    justify-content: center;
    transition: all 0.28s;
    @include icon {
      color: #CFCDE0;
      font-size: 18px;
    }
    &:hover{
      // visibility: visible;
      opacity: 1;
    }
    &:active {
      background: var(--primary-color);
      color: #FFFFFF;
      @include icon {
        color: #FFFFFF;
      }
    }
    @include m(collapse){
      @include icon {
        transform: scaleX(-1);
      }
    }
  }
  @include e(oversea-button){
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 30px;
    border-radius: var(--radius-default);
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    &:hover, &:active {
      background: var(--brand-transparent-active-1);
      @include icon {
        color: var(--primary-color);
      }
    }
    @include icon {
      color: var(--purpleGray-5);
      font-size: 20px;
    }
    @include m(collapse){
      // right: -43px;
      position:fixed;
      left: 13px;
      top: 10px;
      background: transparent;
      // color: rgba(207, 205, 224, 1);
      color: var(--font-color-2);
      &:hover{
        background-color: var(--gray-transparent-hover);
      }
      @include icon {
        color: var(--purpleGray-7);
      }
    }
    @include m(showDrawer){
      position: absolute;
    }
  }

  &:hover{
    // border-right: 4px solid $barBg;
    @include e(button){
      pointer-events: unset;
      visibility: visible;
      opacity: 1;
    }
  }
}
// .zk-left-aside:hover {
//   @include b(aside-toggle){

//     border-right: 4px solid rgba(127, 121, 235, 1);
//     @include e(button){
//       pointer-events: unset;
//       visibility: visible;
//       opacity: 1;
//     }
//   }
// }
</style>
